import React from 'react';

interface ArrowLeftIconProps extends React.SVGProps<SVGSVGElement> {}

const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="none" // Ensure no stroke for a solid fill
    {...props}
  >
    <path
      d="M16 6 L6 12 L16 18 Z" // Solid triangle pointing left, slightly different coordinates
    />
  </svg>
);

export default ArrowLeftIcon;